import React, { useCallback, useRef } from 'react';

import PropTypes from 'prop-types';
import { MdDelete, MdEdit } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { Button, SingleConfirmationModal } from '@shared/components';

import styles from './MainRow.less';

function MainRowButtons({ deleteConfirmationMessage, onDelete, onEdit }) {
  const closeDeleteModalRef = useRef();
  const handleConfirmationDeleteModal = useCallback(() => {
    closeDeleteModalRef.current.openConfirmationModal();
  }, []);

  return (
    <div className={styles.buttonsWrapper}>
      <SingleConfirmationModal
        ref={closeDeleteModalRef}
        message={deleteConfirmationMessage}
        onConfirm={onDelete}
        roundedModal
      />
      <Button
        className={styles.button}
        fitText
        icon={<MdEdit />}
        ghost
        noBorder
        uppercase={false}
        onClick={onEdit}
      >
        <FormattedMessage id="packRoster.MainRow.editSubUnit" />
      </Button>
      <Button
        className={styles.button}
        fitText
        icon={<MdDelete />}
        ghost
        noBorder
        uppercase={false}
        onClick={handleConfirmationDeleteModal}
      >
        <FormattedMessage id="packRoster.MainRow.deleteSubUnit" />
      </Button>
    </div>
  );
}

MainRowButtons.propTypes = {
  deleteConfirmationMessage: PropTypes.node.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

MainRowButtons.defaultProps = {
  onDelete: () => {},
  onEdit: () => {},
};

export default MainRowButtons;
